import z from 'zod';

import { TAX_INFO_FORM_FIELDS } from './types';

export const TaxInfoShape = z.object({
	[TAX_INFO_FORM_FIELDS.country]: z.string().min(1, { message: 'Country is required' }),
	[TAX_INFO_FORM_FIELDS.number]: z.string().optional().nullable(),
	[TAX_INFO_FORM_FIELDS.authority]: z.string().optional().nullable(),
});
